import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { BaseApiRepository } from '../repositories/base-api-repository';
import { SepImpersonationSessionData } from './session-storage/SepSessionStorage';

export interface FeatureFlagResponseDTO {
  name: string;
  isEnabled: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService extends BaseApiRepository {
  private flags: Record<string, boolean> = {};

  hris = 'feature_flag_hris';
  courseVariables = 'feature_flag_course_variables';
  certificates = 'feature_flag_certificates';

  constructor() {
    super();
  }

  async loadFeatureFlags(impersonationHeaders?: HttpHeaders) {
    const path = '/FeatureFlags';
    try {
      const featureFlags = await firstValueFrom(
        this.sendGetRequest<FeatureFlagResponseDTO[]>(
          path,
          undefined,
          impersonationHeaders,
        ),
      );
      this.flags = featureFlags.reduce((acc: Record<string, boolean>, f) => {
        acc[f.name] = f.isEnabled;
        return acc;
      }, {});
    } catch {
      this.flags = {};
    }
  }

  isFeatureEnabled(featureName: string): boolean {
    return this.flags[featureName];
  }

  getImpersonationHeaders(
    impersonationSessionData: SepImpersonationSessionData | null,
  ) {
    const impersonatedTenantId =
      impersonationSessionData?.organization.tenant.id;
    if (!impersonatedTenantId) {
      return undefined;
    }
    let headers = new HttpHeaders();
    headers = headers.set('X-TENANT-ID', impersonatedTenantId);
    return headers;
  }
}
